export enum ExchangeAccountStatus {
    ACTIVE = 'ACTIVE',
    DELETED_FROM_EXCHANGE = 'DELETED_FROM_EXCHANGE',
    DELETED_FROM_SYSTEM = 'DELETED_FROM_SYSTEM'
}
